import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import MarkdownItVueLight from 'markdown-it-vue/dist/markdown-it-vue-light.umd.min.js';
export default {
  name: 'ViewApi',
  components: {
    MarkdownItVueLight: MarkdownItVueLight
  },
  data: function data() {
    return {
      buttons01: [{
        title: this.$i18n_t('Common.open'),
        icon: 'fal fa-external-link',
        action: 'open',
        valid: true
      }]
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color'])), {}, {
    n1Protocol: function n1Protocol() {
      return process.env.VUE_APP_N1_API_PROTOCOL;
    },
    n1Host: function n1Host() {
      return process.env.VUE_APP_N1_API_HOST;
    },
    xapiHost: function xapiHost() {
      // set --build-arg VUE_APP_XAPI_HOST=https://xapi-subdomain.domain.com in case you need it for customer on-prem installation
      return process.env.VUE_APP_XAPI_HOST;
    },
    fireflyHost: function fireflyHost() {
      return process.env.VUE_APP_FIREFLY_HOST;
    },
    // n20aUrl() {
    //   return process.env.VUE_APP_ENV === 'local'
    //     ? 'http://xapi.127.0.0.1.xip.io'
    //     : `${this.n1Protocol}://xapi.${this.n1Host}`;
    // },
    n20aText: function n20aText() {
      return this.$i18n_t('Common.api.n20a', {
        url: this.xapiHost ? "".concat(this.n1Protocol, "://").concat(this.xapiHost, "/swagger/v1/") : "".concat(this.n1Protocol, "://xapi.").concat(this.n1Host, "/swagger/v1/")
      });
    }
  }),
  methods: {
    open: function open(a) {
      var link;

      if (a === 'n20a') {
        link = this.xapiHost ? "".concat(this.n1Protocol, "://").concat(this.xapiHost, "/swagger/v1/") : "".concat(this.n1Protocol, "://xapi.").concat(this.n1Host, "/swagger/v1/");
      }

      if (a === 'n10a') {
        link = 'https://apidocs.niota.io';
      }

      if (a === 'firefly') {
        link = "https://apidocs.".concat(this.fireflyHost);
      }

      window.open(link, '_blank');
    }
  }
};